import { useReducer, createContext, useState, useEffect } from 'react';
import { IntlProvider } from 'react-intl';

import RodaApp from './RodaApp';

import './App.css';

// import messages from './messages.json';

const defaultState = {
  appSettings: {
    buildVersion: '1.5.8',
    version: 'roda-v1',
    production: false,
    language: 'ita',
    isAppActive: true,
    filter: {
      init: 'categories'
    },
    subheaderText: {
      info: null,
      title: null,
      note: 'categories_note'
    },
    isArticleSelected: false,
    isShared: false,
    isSideMenuOpen: true,
    sideMenuTabs: ['modify', 'finishes', 'add'],
    tab: 'modify',
    isSummaryOpen:  false
  },
  data: {
    messages: {},
    rodaMaterials: undefined,
    compositionMaterials: undefined,
    articles: undefined
  },
  selections: {
    collectionName: undefined,
    designer: undefined,
    materials: undefined,
    fabrics: undefined,
    articles: undefined
  },
  specs: undefined
};

const setFilter = (filter, payload) => {
  const { filterName, value } = payload;
  let newFilter = {};
  if (filterName === 'init') {
    newFilter.init = value
  } else {
    newFilter = {...filter}
    newFilter[filterName] = value;
  };
  return newFilter;
};

const loopOverSelections = (appState, data) => {
  // console.log('SETTING SELECTIONS', data)
  const { itemID, prop, value } = data;
  if (prop === 'materials') {
    appState.selections.materials = value;
  } else if (prop === 'fabrics') {
    appState.selections.fabrics = value;
  } else if (prop === 'articles') {
    // if (appState.selections.articles !== undefined) {
    //   appState.selections.articles.filter(art => art.id === itemID)[0] = value;
    // } else {
      appState.selections.articles = value;
    
    // console.log('hgjh', appState)
    // appState.composition.lamps.filter(i => i.lampID === lampId)[0][prop] = value;
  } else {
    appState.selections = value
  };
  return appState;
};

const resetApp = (appState, payload) => {
  const EXEPTION_KEYS = ['language', 'messages', 'rodaMaterials']
  
  Object.keys(appState).forEach(key => {
    // console.log('KEY',key, Object.keys(appState[key]).length);
    if (key === 'specs') {
      appState.specs = undefined;
    } else {
      let subkeys = Object.keys(appState[key]);
      subkeys.forEach(subkey => {
        if (!EXEPTION_KEYS.includes(subkey)) {
          // console.log('some', key, subkey, defaultState[key])
          if (subkey !== undefined) {
            appState[key][subkey] = defaultState[key][subkey];
          };
        }
      });
    };
  });
  return appState;
};

const reducer = (appState, action) => {
  switch(action.type) {
    case 'SET_IS_APP_ACTIVE'              : return {...appState, appSettings: {...appState.appSettings, isAppActive: action.payload}};
    case 'SET_LANGUAGE'                   : return {...appState, appSettings: {...appState.appSettings, language: action.payload}};
    case 'SET_FILTER'                     : return {...appState, appSettings: {...appState.appSettings, filter: setFilter(appState.appSettings.filter, action.payload)}};
    case 'SET_SUBHEADER_TEXT'             : return {...appState, appSettings: {...appState.appSettings, subheaderText: action.payload}};
    case 'TOGGLE_SIDEMENU'                : return {...appState, appSettings: {...appState.appSettings, isSideMenuOpen: action.payload}};
    case 'TOGGLE_IS_ARTICLE_SELECTED'     : return {...appState, appSettings: {...appState.appSettings, isArticleSelected: action.payload}};
    case 'SET_IS_SHARED'                  : return {...appState, appSettings: {...appState.appSettings, isShared: action.payload}};
    case 'SET_TAB'                        : return {...appState, appSettings: {...appState.appSettings, tab: action.payload}};
    case 'TOGGLE_SUMMARY_OPEN'            : return {...appState, appSettings: {...appState.appSettings, isSummaryOpen: action.payload}};
    case 'RESET_APP'                      : return resetApp(appState, action.payload);

    case 'SET_MESSAGES'                   : return {...appState, data: {...appState.data, messages: action.payload}};
    case 'SET_ARTICLES_DATA'              : return {...appState, data: {...appState.data, articles: action.payload}};
    case 'SET_RODA_MATERIALS'             : return {...appState, data: {...appState.data, rodaMaterials: action.payload}};
    case 'SET_COMPOSITION_MATERIALS'      : return {...appState, data: {...appState.data, compositionMaterials: action.payload}};
    case 'SET_COMPOSITION_ARTICLES'       : return {...appState, data: {...appState.composition, articles: action.payload}};

    case 'SET_COLLECTION_NAME'            : return {...appState, selections: {...appState.selections, collectionName: action.payload}};
    case 'SET_DESIGNER'                   : return {...appState, selections: {...appState.selections, designer: action.payload}};
    case 'SET_USER_SELECTIONS'            : return loopOverSelections(appState, action.payload);
    case 'SET_COMPOSITION'                : return {...appState, selections: action.payload};
    case 'SET_SPECS'                      : return {...appState, specs: action.payload};
    case 'SET_ARTICLES'                   : return {...appState, selections: {...appState.selections, articles: action.payload}};
    case 'SET_FABRICS'                    : return {...appState, selections: {...appState.selections, fabrics: action.payload}};
    case 'SET_MATERIALS'                  : return {...appState, selections: {...appState.selections, materials: action.payload}};
    default: throw new Error (`no matching action ${action.type}`);
  }
};

export const StateContext = createContext(defaultState);
export const DispatchContext = createContext();

function App() {
  const [ appState, dispatch ] = useReducer(reducer, defaultState);
  const [ messages, setMessages ] = useState();
  const { production, language } = appState.appSettings;
  let proxy = production ? '' : 'https://serene-springs-29711.herokuapp.com/';

  const getLabels = async (lang) => {
    lang = lang.slice(0, 2);
    await fetch(`${proxy}https://rodabackend.com/mocked_api/v1/labels/${lang}/`)
    .then(res => res.json())
    .then(data => {
        if (data) {
          dispatch({
            type: 'SET_MESSAGES',
            payload: data
          })
          setMessages(data);
        } else {
          console.error('no labels recieved')
        }
    })
    .catch(error => {
      console.log(error); 
    });   
  };

  useEffect(() => {
    let fetching = true;
    const getMaterials = async (itemMaterials) => {
            
      await fetch (`${proxy}https://rodabackend.com/mocked_api/v1/materials/`)
      .then(res => res.json())
      .then(data => {
        if (fetching) {
          if (data) {
            //Data array contains image urls and color names
            dispatch({
              type: 'SET_RODA_MATERIALS',
              payload: data
            });
            // setRodaMaterials(data);
            // let materials = itemMaterials.slice();
            // materials.forEach((material, _i) => {
            //   material.colors.forEach(color => {
            //     let newData = data.filter(i => i.id === color)[0];
            //     materials[_i].colors.splice(materials[_i].colors.indexOf(color), 1, newData)
            //   })
            // });
            // setDefaultMaterials(materials);
            // // console.log('materials', materials)
            // setMaterials(materials);
          };
        };
      })
      .catch(error => {
        console.log(error)
      });
      
    };

    getMaterials();
    return () => {
      fetching =  false;
    }
  }, [])

  useEffect(() => {
    let fetching = true;
    if (fetching) {
      if(language) {
        getLabels(language);
      } 
    }
    return () => {
      fetching = false;
    }; 
  }, [language]);

  return (
    <StateContext.Provider value={appState}>
      <DispatchContext.Provider value={dispatch}>
          <IntlProvider messages={messages} locale='it' defaultLocale='it'>
            <RodaApp/>
          </IntlProvider>
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};

export default App;
